'use strict';

const LoginDirective = function () {

  const link = (scope, el) => {

    el.addClass('full-height login-page-container');
  };

  /////////////////////////////////////////////////////////////////////////////////////////////////
  // Directive Definition Object
  /////////////////////////////////////////////////////////////////////////////////////////////////

  return {
    bindToController: true,
    controller: 'LoginFormController',
    controllerAs: 'vm',
    link,
    templateUrl: 'login/loginForm/loginForm.tpl.html'
  };
};

module.exports = LoginDirective;



// WEBPACK FOOTER //
// ./src/app/login/loginForm/LoginFormDirective.js